module.exports = __webpack_public_path__ + "img/bsn_5.bd6d8f79.png";